module.exports = __webpack_public_path__ + "img/serifnew_box12.e246d0fc.jpg";